import { Injectable } from '@angular/core';
import { Menu } from './menu.component';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class MenuManager {
    private menus: Map<string, Menu> = new Map();

    public register(menu: Menu): void {
        menu.id = uuidv4();
        this.menus.set(menu.id, menu);
    }

    public get(id: string): Menu | undefined {
        return this.menus.get(id);
    }

    public hideAll(): void {
        this.menus.forEach((menu) => {
            menu.hide();
        });
    }
}
